// Centralni dizajn-sistem (Faza 4, UI-01).
// VAŽNO: vrednosti su IDENTIČNE postojećim bojama u kodu, uvođenje tokena
// NE menja izgled sajta, samo omogućava da se izgled ubuduće menja sa jednog
// mesta (umesto ~850 hardkodovanih pojava).
const theme = {
  colors: {
    // Brend (narandžasta ostaje)
    primary: "#ff6b35",
    primaryHover: "#e55a2b",
    primaryLight: "#ff8c42",

    // Pozadine (tamna tema ostaje)
    bg: "#2c2c2c",
    surface: "#333333",
    surfaceElevated: "#1a1a1a",
    surfaceAlt: "#2a2a2a",

    // Tekst
    textPrimary: "#ffffff",
    textMuted: "#cccccc",
    textSubtle: "#888888",

    // Ivice
    border: "#444444",
    borderStrong: "#555555",

    // Statusi
    success: "#27ae60",
    successHover: "#229954",
    danger: "#e74c3c",
    dangerHover: "#c0392b",
    warning: "#f39c12",
    warningHover: "#e67e22",
    info: "#3498db",

    black: "#000000",
    white: "#ffffff",
  },

  spacing: {
    xs: "4px",
    sm: "8px",
    md: "12px",
    lg: "16px",
    xl: "24px",
    "2xl": "32px",
    "3xl": "48px",
    "4xl": "64px",
  },

  radius: { sm: "4px", md: "8px", lg: "12px", pill: "999px" },

  fonts: {
    regular: '"Poppins-Regular", sans-serif',
    semibold: '"Poppins-SemiBold", sans-serif',
    bold: '"Poppins-Bold", sans-serif',
  },

  fontSize: {
    xs: "12px",
    sm: "14px",
    base: "16px",
    lg: "20px",
    xl: "24px",
    "2xl": "32px",
    "3xl": "40px",
  },

  breakpoints: {
    phone: "600px",
    tabletPortrait: "900px",
    tabletLandscape: "1200px",
    desktop: "1800px",
  },
};

export default theme;
